export const VaultDescription = ({ description }: { description: string }) => {
	return (
		<div className="flex flex-col gap-4">
			<span className="typo-t3 text-text-default">Description</span>
			<span className="typo-b4 text-text-secondary">{description}</span>
		</div>
	);
};
